import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';
import { Persona } from '@/shared/model/persona/persona.model';
import { Solucion } from '@/shared/model/seguimiento/solucion.model';
import { PeriodoBeca } from '@/shared/model/seguimiento/periodo-beca.model';
import { Programa } from '@/shared/model/seguimiento/programa.model';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { DependienteEconomico } from '@/shared/model/seguimiento/dependiente-economico.model';
import * as personaUtils from '@/shared/util/format-util';
import resolveEstadoBecaVariant from '@/shared/estados/estados-beca.util';
import { MotivoMovimientoBeca } from '@/shared/model/seguimiento/administrativo/motivo-movimiento-beca.model';
import { Pago } from '@/shared/model/seguimiento/financiero/pago.model';
import { Apoyo } from '@/shared/model/seguimiento/extranjeras/apoyo.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Rubro } from '@/shared/model/rubro.model';

export interface IBeca {
  id?: string | null;
  numeroApoyo?: string | null;
  estadoActual?: EstadoBeca | null;
  solicitud?: Solicitud | null;
  solicitudRizomaId?: string | null;
  solucionSolicitud?: Solucion | null;
  becario?: Persona | null;
  dependientesEconomicos?: DependienteEconomico[] | null;
  periodoBeca?: PeriodoBeca | null;
  programa?: Programa | null;
  bitacoraLiberacionBecasId?: string | null;
  tieneAjusteVigencia?: boolean | false;
  checked?: boolean | false;
  nombrePrograma?: string | null;
  convocatoria?: string | null;
  nombreCompleto?: string | null;
  variant?: string | null;
  motivoMovimientoBecaBaja?: MotivoMovimientoBeca | null;
  ultimoPago?: Pago | null;
  cuentaBancaria?: string | null;
  estatusCuenta?: string | null;
  origen?: string | null;
  fechaInicioMovilidad?: string | null;
  fechaFinMovilidad?: string | null;
  tags?: string[] | null;
}

export class Beca implements IBeca {
  constructor(
    public id?: string | null,
    public numeroApoyo?: string | null,
    public estadoActual?: EstadoBeca | null,
    public solicitud?: Solicitud | null,
    public solicitudRizomaId?: string | null,
    public solucionSolicitud?: Solucion | null,
    public becario?: Persona | null,
    public dependientesEconomicos?: DependienteEconomico[] | null,
    public periodoBeca?: PeriodoBeca | null,
    public programa?: Programa | null,
    public bitacoraLiberacionBecasId?: string | null,
    public tieneAjusteVigencia?: boolean | false,
    public checked?: boolean | false,
    public nombrePrograma?: string | null,
    public convocatoria?: string | null,
    public nombreCompleto?: string | null,
    public variant?: string | null,
    public motivoMovimientoBecaBaja?: MotivoMovimientoBeca,
    public ultimoPago?: Pago,
    public apoyo?: Apoyo,
    public rubros?: Rubro[],
    public cuentaBancaria?: string | null,
    public estatusCuenta?: string | null,
    public tipoBecaExtranjero?: string | null,
    public origen?: string | null,
    public fechaInicioMovilidad?: string | null,
    public fechaFinMovilidad?: string | null,
    public tags?: string[] | null
  ) {
    this.becario = this.becario ? this.becario : new Persona();
    this.periodoBeca = this.periodoBeca ? this.periodoBeca : new PeriodoBeca();
    this.programa = this.programa ? this.programa : new Programa();
    this.solucionSolicitud = this.solucionSolicitud ? this.solucionSolicitud : new Solucion();
    this.motivoMovimientoBecaBaja = this.motivoMovimientoBecaBaja ? this.motivoMovimientoBecaBaja : new MotivoMovimientoBeca();
    this.ultimoPago = this.ultimoPago ? this.ultimoPago : new Pago();
    this.apoyo = this.apoyo ? this.apoyo : new Apoyo();
    this.rubros = this.rubros;
  }

  static ubicacionBeca(tipoSolucion: TipoSolucion) {
    switch (tipoSolucion) {
      case TipoSolucion.BECAS_NACIONALES:
        return 'NACIONAL';
      case TipoSolucion.BECAS_EXTRANJERAS:
        return 'EXTRANJERA';
      default:
        return '';
    }
  }

  static fromObject(data: IBeca): Beca {
    const beca = new Beca();
    for (const [key, value] of Object.entries(data)) {
      beca[key] = value;
    }

    beca.nombreCompleto = personaUtils.fullName(beca?.becario);
    beca.nombrePrograma = beca.programa?.nombre;
    beca.convocatoria = beca.solucionSolicitud?.nombreConvocatoria;
    beca.variant = resolveEstadoBecaVariant(beca?.estadoActual);
    return beca;
  }
}

export interface IBecaSeleccion {
  checkedTabla?: boolean;
  beca?: IBeca;
}

export class BecaSeleccion {
  constructor(public checkedTabla?: boolean, public beca?: IBeca) {}
}
